import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { sms: () => import('./SmsPage.vue') },
} satisfies FeatureRoutes
